import axios from 'axios';
import {callAndRetryOnError, getCurrentEnvironmentConfig, logger} from './AppUtil';

let tokenData = {};

/**
 * Handles the in memory storage of tokens and the syncing back and forth to the server.
 *
 * The reason behind this class
 * USER-4084 Using the hub listener to set and delete the cookies from the server side
 * to get around Safari's 7 day security limitations.
 */
export class AmplifyCustomStorage {

    static getTokenData() {
        return tokenData;
    }

    static setItem(key, value) {
        tokenData[key] = value;
        return tokenData[key];
    }

    static getItem(key) {
        return tokenData[key];
    }

    static removeItem(key) {
        delete tokenData[key];
    }

    static clear() {
        tokenData = {};
        AmplifyCustomStorage.tokenSyncPromise = null;
    }

    static sync() {

        if(!AmplifyCustomStorage.tokenSyncPromise) {
            AmplifyCustomStorage.tokenSyncPromise =  new Promise((resolve, reject) => {

                const urlBasePath = getCurrentEnvironmentConfig().ssoBaseUrl;
                const getTokensCall = () => {
                    return axios.get(`${urlBasePath}/sso/v2/tokens`, {
                        withCredentials: true,
                        headers: {
                            'content-type': 'application/json; charset=utf-8',
                            'Cache-Control': 'no-cache, no-store, must-revalidate',
                            'Pragma': 'no-cache',
                            'Expires': '0'
                        }
                    });
                };

                callAndRetryOnError(getTokensCall, 3, 500).then((result) => {
                    if(result.status === 200) {
                        result.data.forEach(token => {
                            AmplifyCustomStorage.setItem(decodeURIComponent(token.name), decodeURIComponent(token.value));
                        });
                    }
                }).catch((e) => {
                    logger.error({
                        appContext: {
                            msg: "AmplifyCustomStorage.sync Failure: Token GET",
                            errorStringified: JSON.stringify(e), realError: e
                        }
                    });
                }).finally(() => {
                    resolve();
                });
            });
        }
        return AmplifyCustomStorage.tokenSyncPromise;
    }

}